import React from 'react'
import { Grid } from '@mui/material'
import { useNavigate } from 'react-router-dom';

import PendingTable from "../PendingTickets/Table";
import RecentTable from "../RecentUploads/Table";
import NoAccessTable from "../Noaccess/Table";
import PendingIcon from "../../../../../styles/svg/pending-table.svg";
import RecentIcon from "../../../../../styles/svg/recent-upload-table.svg";
import RightArrow from "../../../../../styles/svg/right-arrow-icon.svg";
import Heading from '../../../../../components/Heading';
import BackButton from '../../../../../components/BackButton';

function Inspections() {
    const user = JSON.parse(localStorage.getItem("userData"));
    const role = user?.role;
    const redirect = useNavigate();
     const viewAll = (status) => {
       redirect(`/client/${user.role_id}/tickets?status=${status}`);
     }; 
  return (
    <div>
        <Heading title="Inspections: Lead XRF/Dustwipes" >
        <BackButton/>
        </Heading>
      <Grid container spacing={4} sx={{ marginTop: 0 }}>
        <Grid item xs={12} md={6}>
          <div className="tickets-filter d-flex  align-items-center justify-content-space-between bg-white">
            <div className="d-flex">
              <img src={PendingIcon} alt="Pending Icon" />
              <p className="heading-title-name ml-2">Pending Tickets</p>
            </div>
            {role == "client" && (
              <div
                className="d-flex cursor-pointer"
                onClick={() => viewAll("Pending")}
              >
                <p className="view-all">View All</p>
                <img src={RightArrow} />
              </div>
            )}
          </div>
          <PendingTable />
        </Grid>
        <Grid item xs={12} md={6}>
          <div className="tickets-filter d-flex align-items-center justify-content-space-between bg-white">
            <div className="d-flex">
              <img src={RecentIcon} />
              <p className="heading-title-name ml-2">Recent Uploads</p>
            </div>
            {role == "client" && (
              <div
                className="d-flex cursor-pointer"
                onClick={() => viewAll("Recently Uploaded")}
              >
                <p className="view-all">View All</p>
                <img src={RightArrow} />
              </div>
            )}
          </div>
          <RecentTable />
        </Grid>
        <Grid item xs={12} md={12}>
          <div className="tickets-filter d-flex  align-items-center justify-content-space-between bg-white">
            <div className="d-flex">
              <img src={PendingIcon} />
              <p className="heading-title-name ml-2">No Access</p>
            </div>
            {role == "client" && (
              <div
                className="d-flex cursor-pointer"
                onClick={() => viewAll("No Access")}
              >
                <p className="view-all">View All</p>
                <img src={RightArrow} />
              </div>
            )}
          </div>
          <NoAccessTable />
        </Grid>
      </Grid>
    </div>
  );
}

export default Inspections